// extracted by mini-css-extract-plugin
export default {"sticked":"aEwULT"};